































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import axios, { resHandle } from "@/plugins/axios";
import * as _ from "lodash";
import {
  InstitutionList,
  CreatorList,
  PatientList,
  GetTemplatesOfGroup,
  GetTopicsOfTemplate,
} from "@/request/zhuanbingshujuku";
import { GetUserInfo, ZuzhijiagouList } from "@/request/yonghuquanxian";
import Pagination from "@/components/paginaiton.vue";
import Copy from "@/components/copy.vue";
import AddPatient from "./add-patient.vue";
import SelectMultiSearch from "./select-multi-search.vue";
import ComposePatient from "../zbsjk-detail/compose-patient.vue";
@Component({
  components: {
    Copy,
    Pagination,
    AddPatient,
    SelectMultiSearch,
    ComposePatient,
  },
})
export default class ZbsjkPatientList extends Vue {
  // 当前用户信息
  private user: any = { role: {} };
  private filters: any = {
    institution_id: "",
    user_ids: [],
    性别: "",
    search: "",
    开始时间: "",
    结束时间: "",
    年龄段: [],
    timeWay: "",
    time: [],
    条件: "",
    研究指标: [],
    自定义年龄: [false],
    时间段: "",
    自定义时间段: [false, []],
    currentPage: 1,
    totalPage: 0,
    totalCount: 0,
    pageSize: 10,
    cSortField: "更新时间",
    cSortValue: "0",
    ifPrimarySearched: false,
  };
  private ifLoading: boolean = false;
  // 搜索条件
  private institutions: any[] = [];
  private creators: any[] = [];
  private saveModel: "add" | "delete" = "add";
  // 选择
  private isIndeterminate: boolean = false;
  private checkAll: boolean = false;
  private selectedMessages: any[] = [];
  // 列表
  private patients: any[] = [];
  // 添加患者
  private ifShowAddPatient: boolean = false;
  private cPatient: any = {};
  // 高级筛选
  private ifShowPrimarySearch: boolean = false;
  private ifShowPrimaryFilter: boolean = false;
  private searchedTemplates: any[] = [];
  // 修改基本信息
  private tempP: any = {};
  private ifShowComposePatient: boolean = false;

  @Watch("center", { immediate: true, deep: true })
  private centerChange(e) {
    const localFilters = localStorage.getItem("zbsjkFilters");
    if (!localFilters) {
      this.$set(this, "filters", {
        institution_id: "",
        范围: [],
        user_ids: [],
        性别: "",
        search: "",
        开始时间: "",
        结束时间: "",
        年龄段: [],
        timeWay: "",
        time: [],
        条件: "",
        研究指标: [],
        自定义年龄: [false],
        时间段: "",
        自定义时间段: [false, []],
        currentPage: 1,
        totalPage: 0,
        totalCount: 0,
        pageSize: 10,
        cSortField: "更新时间",
        cSortValue: "0",
        ifPrimarySearched: false,
      });
    } else {
      this.$set(this, "filters", JSON.parse(localFilters));
    }
    if (e.project_id) {
      this.getCurrentUserInfo();
      this.fetchPatients().then(() => {
        this.getInstitutions();
      });
    }
  }
  private setFilters() {
    localStorage.setItem("zbsjkFilters", JSON.stringify(this.filters));
  }
  private get center() {
    const localCenter = localStorage.getItem("center");
    if (!localCenter) {
      return {};
    } else {
      return JSON.parse(localCenter);
    }
  }
  /**
   * @description 获取当前用户信息
   */
  private getCurrentUserInfo() {
    if (!this.center.project_id) {
      return;
    }
    const params: any = {
      params: {
        project_id: this.center.project_id,
      },
    };
    GetUserInfo(this, params).then((data: any) => {
      this.$set(this, "user", data);
    });
  }
  /**
   * @description 判断当前用户在当前机构下能否显示某个功能
   */
  private canThisRoleUse(tool) {
    let canUse = false;
    try {
      switch (tool) {
        case "批量导出":
          if (
            this.$store.state.roleControl[tool].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            canUse = true;
          }
          break;
        case "操作":
          if (
            this.$store.state.roleControl["数据录入"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            canUse = true;
          }
          break;
        case "新增患者":
          if (
            this.$store.state.roleControl["数据录入"].indexOf(
              this.user["role"]["名称"]
            ) !== -1
          ) {
            canUse = true;
          }
          break;
      }
    } catch (e) {
      console.log(e);
    }
    return canUse;
  }
  /**
   * @description 搜索可选的机构
   */
  private getInstitutions() {
    const params: any = {
      params: {
        project_id: this.center.project_id,
      },
    };
    ZuzhijiagouList(this, params).then((data: any) => {
      this.institutions = _.uniqBy(data, "institution_id");
    });
  }
  /**
   * @description 选择机构改变
   */
  private institutionChange() {
    this.filters.user_ids = [];
    this.getCreatorsList();
    this.search();
  }
  /**
   * @description 获得可选的创建者列表
   */
  private getCreatorsList() {
    const params: any = {
      project_id: this.center.project_id,
      institution_id: [this.filters.institution_id], // 暂时为空选择全部
    };
    CreatorList(this, params).then((data: any) => {
      this.creators = data;
    });
  }
  /**
   * @description 创建人改变
   */
  private creatorsChange() {
    this.search();
  }
  /**
   * @description 添加档案
   */
  private addPatient() {
    this.ifShowAddPatient = true;
  }
  /**
   * @description 打开高级筛选
   */
  private openPrimarySearch() {
    this.fetchTemplates();
    this.ifShowPrimarySearch = true;
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.filters["研究指标"].push({ result: {}, selected: {} });
  }
  /**
   * @description 获取当前分组下的可选模板列表
   */
  private fetchTemplates() {
    GetTemplatesOfGroup(
      this,
      this.center.project_id,
      this.center.group_id
    ).then((data: any) => {
      this.searchedTemplates = data;
    });
  }
  /**
   * @description 搜索模板下具体的字段
   */
  private searchItems(l) {
    GetTopicsOfTemplate(this, l.template_id).then((data: any) => {
      l.items = data;
      this.$forceUpdate();
    });
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["研究指标"].splice(index, 1);
  }
  /**
   * @description 重置高级搜索
   */
  private resetPrimarySearch() {
    this.filters.ifPrimarySearched = false;
    this.ifShowPrimarySearch = false;
    this.filters.timeWay = "";
    this.filters.time = [];
    this.filters["条件"] = "";
    this.filters["研究指标"] = [];
    this.search();
  }
  /**
   * @description 取消高级筛选
   */
  private cancelPrimarySearch() {
    this.ifShowPrimarySearch = false;
  }
  /**
   * @description 确定高级筛选
   */
  private confirmPrimarySearch() {
    this.ifShowPrimarySearch = false;
    this.filters.currentPage = 1;
    this.saveModel = "delete";
    this.filters.ifPrimarySearched = true;
    this.fetchPatients();
  }
  /**
   * @description 跳转数据导出
   */
  private jumpDataExport() {
    this.$router.push({
      path: "/main/zbsjk/zbsjk-data-export",
      query: {
        group_id: this.center.group_id,
        project_id: this.center.project_id,
      },
    });
  }
  /**
   * @description 获取病人列表
   */
  private fetchPatients() {
    return new Promise((resolve, reject) => {
      this.ifLoading = true;
      const params: any = {};
      // 处理基本搜索条件
      params["institution_id"] = this.filters.institution_id;
      params["user_ids"] = this.filters.user_ids;
      params["project_id"] = this.center.project_id;
      params["order_field"] = this.filters.cSortField;
      params["order_value"] = this.filters.cSortValue;
      params["current_page"] = this.filters.currentPage;
      params["page_count"] = this.filters.pageSize;
      params["search"] = this.filters.search;
      params["性别"] = this.filters["性别"];
      params["条件"] = this.filters["条件"];
      // 处理高级筛选
      if (this.filters.timeWay === "自定义") {
        params["开始时间"] = this.filters.time[0];
        params["结束时间"] = this.filters.time[1];
        this.filters.ifPrimarySearched = true;
      }
      if (this.filters["研究指标"].length > 0) {
        this.filters.ifPrimarySearched = true;
        const arr: any[] = [];
        this.filters["研究指标"].map((item: any) => {
          const i = JSON.parse(JSON.stringify(item.selected));
          i.condition = item.result.condition;
          i.value = item.result.value;
          arr.push(i);
        });
        params["研究指标"] = arr;
      }

      PatientList(this, params)
        .then((data: any) => {
          data.patients.forEach((item: any) => {
            item["ifShowMore"] = false;
          });
          this.patients = data.patients;
          this.filters.totalPage = data.total_page;
          this.filters.totalCount = data.total_count;
          if (this.saveModel === "add") {
            this.checkAllMessages(false);
            this.autoCheckSelectedMessages(true);
          } else {
            this.checkAllMessages(true);
            this.autoCheckSelectedMessages(false);
          }
          const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
          this.checkAll = checkedCount === this.patients.length;
          this.isIndeterminate =
            checkedCount > 0 && checkedCount < this.patients.length;
          resolve();
        })
        .catch(() => {
          reject();
        })
        .finally(() => {
          this.setFilters();
          this.ifLoading = false;
        });
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filters.currentPage = 1;
    this.saveModel = "delete";
    this.fetchPatients();
  }
  /**
   * @description 处理翻页器的当前页变化
   */
  private handleCurrentPageChange(val) {
    this.filters.currentPage = val;
    this.fetchPatients();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.filters.cSortField = ev["prop"];
    this.filters.cSortValue = ev["order"] === "ascending" ? "1" : "0";
    this.fetchPatients();
  }
  // 勾选
  /**
   * @description 给所有message勾选上
   */
  private checkAllMessages(isChecked: boolean) {
    this.patients.forEach((message: any, index: number) => {
      this.$set(this.patients[index], "isChecked", isChecked);
    });
    this.isIndeterminate = false;
    this.checkAll = isChecked ? true : false;
  }
  /**
   * @description 增加一个数据到已选列表
   */
  private addOneMessageToSelectedMessages(message: any) {
    this.selectedMessages.push(message);
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 从已选列表中删除一条数据
   */
  private deleteOneMessageFromSelectedMessages(message: any) {
    const index = this.selectedMessages.findIndex(
      (selectedMessage: any) =>
        selectedMessage.patient_id === message.patient_id
    );
    if (index !== -1) {
      this.selectedMessages.splice(index, 1);
    }
  }
  /**
   * @description 增加当前页面所有的消息进入已选列表
   */
  private addAllMessagesToSelectedMessages() {
    this.patients.forEach((message: any) => {
      this.selectedMessages.push(message);
    });
    this.selectedMessages = _.uniq(this.selectedMessages);
  }
  /**
   * @description 将当前页面的所有数据，从已选列表中删除
   */
  private deleteAllMessagesFromSelectedMessages() {
    this.patients.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        this.selectedMessages.splice(targetIndex, 1);
      }
    });
  }
  /**
   * @description 统计当前页面有多少数据被选中
   */
  private countHowMuchCurrentPageMessagesSelected() {
    let checkedCount = 0;
    this.patients.forEach((message: any) => {
      if (message.isChecked) {
        checkedCount++;
      }
    });
    return checkedCount;
  }
  /**
   * @description 翻页后自动勾选上已经选择的数据
   */
  private autoCheckSelectedMessages(isChecked: boolean) {
    this.patients.forEach((message: any) => {
      const targetIndex = this.selectedMessages.findIndex(
        (selectedMessage: any) =>
          selectedMessage.patient_id === message.patient_id
      );
      if (targetIndex !== -1) {
        message.isChecked = isChecked;
      }
    });
  }
  /**
   * @description 处理点击全选
   */
  private handleCheckAllChange(val) {
    if (val) {
      this.checkAllMessages(true);
      if (this.saveModel === "add") {
        this.addAllMessagesToSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.deleteAllMessagesFromSelectedMessages();
      }
    } else {
      this.checkAllMessages(false);
      if (this.saveModel === "add") {
        this.deleteAllMessagesFromSelectedMessages();
      } else if (this.saveModel === "delete") {
        this.addAllMessagesToSelectedMessages();
      }
    }
  }
  /**
   * @description 处理单个勾选
   */
  private handleCheckedMessageChange(val, item) {
    if (val) {
      if (this.saveModel === "add") {
        this.addOneMessageToSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.deleteOneMessageFromSelectedMessages(item);
      }
    } else {
      if (this.saveModel === "add") {
        this.deleteOneMessageFromSelectedMessages(item);
      } else if (this.saveModel === "delete") {
        this.addOneMessageToSelectedMessages(item);
      }
    }
    const checkedCount = this.countHowMuchCurrentPageMessagesSelected();
    this.checkAll = checkedCount === this.patients.length;
    this.isIndeterminate =
      checkedCount > 0 && checkedCount < this.patients.length;
  }
  /**
   * @description 跳转某个病人的某个诊次
   */
  private jumpZhenci(zindex, patient) {
    localStorage.setItem("patient", JSON.stringify(patient));
    localStorage.setItem("addZhenci", "0");
    this.$router.push({
      path: "/main/zbsjk/zbsjk-detail",
      query: {
        zIndex: zindex,
      },
    });
  }
  /**
   * @description 添加诊次
   */
  private addZhenci(patient) {
    localStorage.setItem("patient", JSON.stringify(patient));
    localStorage.setItem("addZhenci", "1");
    this.$router.push({
      path: "/main/zbsjk/zbsjk-detail",
    });
  }
  /**
   * @description 修改基本信息
   */
  private startChangeUserInfo(patient) {
    this.tempP.patient_id = "";
    this.tempP = _.cloneDeep(patient);
    this.ifShowComposePatient = true;
  }
  /**
   * @description 修改患者信息后刷新页面
   */
  private updatePatient() {
    this.tempP = {};
    this.fetchPatients();
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.getCreatorsList();
  }
}
